// @flow

import React, { type Node } from 'react';

import { type LookAndFeelRootPropsPendingPayment } from '@tectonics/look-and-feel';
import { AutoRedirectComponent, IncomingPaymentProvider } from '@tectonics/prs/incoming-payment';
import { PaymentSpecProvider } from '@tectonics/prs/payment-spec';
import { Template } from '@tectonics/look-and-feel/shopify/template';
import { UserInputValuesProvider } from '@tectonics/prs/user-input-values';
import { AnalyticsContextProvider, AnalyticsCachedEvent } from '@tectonics/analytics';

import { ValuesDisplay } from '../../commons/organisms/values-display';
import { Footer } from '../../commons/organisms/footer';
import { PageContent } from './page-content';

export function PendingPaymentPage({
  spec,
  incomingPayment,
  userInputValues,
  onUserInput,
  analytics,
}: LookAndFeelRootPropsPendingPayment): Node {
  return (
    <PaymentSpecProvider spec={spec}>
      <IncomingPaymentProvider incomingPayment={incomingPayment}>
        <UserInputValuesProvider values={userInputValues} setValue={onUserInput}>
          <AnalyticsContextProvider analytics={analytics}>

            <AnalyticsCachedEvent eventType="pageView" />

            <AutoRedirectComponent />
            <Template
              mainContent={<PageContent />}
              displayContent={<ValuesDisplay />}
              footerContent={<Footer />}
            />

          </AnalyticsContextProvider>
        </UserInputValuesProvider>
      </IncomingPaymentProvider>
    </PaymentSpecProvider>
  );
}
